__turbopack_context__.v({
  "ctaContent": "IndividualPromo-module-scss-module__8Pb0nW__ctaContent",
  "title": "IndividualPromo-module-scss-module__8Pb0nW__title",
});
